import React, { memo, useCallback } from 'react';
import { Button } from 'antd';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import styles from './index.module.scss';

export type UnlockNumErrorModalContentProps = {
  conBrandId?: string;
};

const UnlockNumErrorModalContent: React.FC<UnlockNumErrorModalContentProps> = () => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch({ type: 'modal/close' });
  }, [dispatch]);
  return (
    <section className={styles.content}>
      <img src="//assets-oss.cbndata.com/cbndata-refactor-fe/FlgyLZ7mCMnyFG155Ybx0Lun9hCh.svg" alt="解锁失败" />
      <h1 className={styles.title}>解锁数量不足！</h1>
      <span className={styles.text1}>当前品牌解锁数量已不足，有以下方式可获得更多品牌解锁权限</span>
      <span className={styles.text2}>方式一：为已解锁品牌的指标进行评分，最多可额外解锁30个品牌</span>
      <span className={styles.text2}>方式二：联系客服升级会员等级，解锁更多品牌</span>
      <Link href="/member">
        <Button className={styles.btn} type="primary" size="large" onClick={onClick}>
          去升级会员
        </Button>
      </Link>
    </section>
  );
};

export default memo(UnlockNumErrorModalContent);
